<template>
    <div class="business-content-main" :style="getMainStyle()">
        <div style="margin-right: 70px">
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="packing-order-infoes">
                <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%" :rules="rules">
                    <div class="form-main">
                        <el-form-item label="装箱单号" size="small" prop="PackingCode">
                            <el-input style="width: 200px" disabled placeholder="自动生成" v-model="submitData.PackingCode"></el-input>
                        </el-form-item>
                        <el-form-item label="装箱时间" prop="PackingTime">
                            <el-date-picker :disabled="dataReadonly" size="small" v-model="submitData.PackingTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="装箱员" prop="SId">
                            <el-select v-model="submitData.SId" :disabled="dataReadonly" filterable clearable remote size="small" placeholder="请选择" style="width: 100px">
                                <el-option v-for="(item, idx) in SIdList" :key="idx" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注" prop="Remark">
                            <el-input style="width: 300px" v-model="submitData.Remark" :disabled="dataReadonly" size="small" :title="submitData.Remark"></el-input>
                        </el-form-item>
                        <el-button
                            :disabled="saleOrderSelected"
                            size="small"
                            class="btn-primary search-btn"
                            v-if="type != 1 && submitData.SubmissionState == 0"
                            @click="submitForm(0)"
                            >保存装箱单</el-button
                        >
                        <el-button :disabled="saleOrderSelected" size="small" class="btn-primary search-btn" v-if="type != 1" @click="submitForm(1)">提交装箱单</el-button>
                    </div>
                </el-form>
            </div>
            <div class="section-title">
                <div>
                    <span>销售订单信息</span>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showOrderDialog()" v-if="type == 0">选择销售单</el-button>
                </div>
            </div>
            <div class="search-ctn packing-order-infoes" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 15px; padding-left: 15px">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="客户名称" prop="EntpCusName">
                                    <el-input size="small" style="width: 100%" disabled v-model="OrderData.EntpCusName" :title="OrderData.EntpCusName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="发货方式" prop="ShipType">
                                    <el-input size="small" style="width: 100%" disabled v-model="OrderData.ShipTypeName" :title="OrderData.ShipTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="业务员" prop="OrderSale">
                                    <el-input size="small" style="width: 100%" disabled v-model="OrderData.SName" :title="OrderData.SName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="收货地址" prop="FullAddress">
                                    <el-input size="small" style="width: 100%" disabled v-model="OrderData.FullAddress" :title="OrderData.FullAddress"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="客人要求" prop="SaleRemark">
                                    <el-input size="small" style="width: 100%" disabled v-model="OrderData.Remark" :title="OrderData.Remark"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content">
                                <el-form-item label="销售单号">
                                    <div class="codetags">
                                        <el-tag v-for="(item, index) in saleOrderCodeList" @click="showSalesDetails(item.EntpCusOId)" :key="index">{{ item.OrderCode }}</el-tag>
                                    </div>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title">
                <div>
                    装箱商品明细
                    <span style="font-size: 14px; margin-left: 10px; color: red">（ 温馨提醒：已过滤已装箱商品！重新选择销售单进行装箱会清空当前数据，请谨慎操作！）</span>
                </div>
            </div>
            <!--      table title      -->
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 3%; flex-grow: 1">序号</div>
                <div class="div-table-cell table-cell-apcode">汽配编码</div>
                <div class="div-table-cell" style="width: 10%">配件名称</div>
                <div class="div-table-cell" style="width: 10%">车型</div>
                <div class="div-table-cell" style="width: 3%">数量</div>
                <div class="div-table-cell" style="width: 3%">单位</div>
                <div class="div-table-cell" style="width: 10%">箱号</div>
                <div class="div-table-cell" style="width: 5%">数量/箱</div>
                <div class="div-table-cell" style="width: 5%">箱数</div>
                <div class="div-table-cell" style="width: 5%">总个数</div>
                <div class="div-table-cell" style="width: 5%">箱长(cm)</div>
                <div class="div-table-cell" style="width: 5%">箱宽(cm)</div>
                <div class="div-table-cell" style="width: 5%">箱高(cm)</div>
                <div class="div-table-cell" style="width: 5%">体积(m³)</div>
                <div class="div-table-cell" style="width: 5%">总体积(m³)</div>
                <div class="div-table-cell" style="width: 5%">重量(kg)</div>
                <div class="div-table-cell" style="width: 5%">总重量(kg)</div>
            </div>
        </div>
        <div
            id="infinite-list"
            class="infinite-list"
            :style="{ height: infiniteListHeight + 'px' }"
            v-infinite-scroll="loadDownScroll"
            infinite-scroll-distance="200"
            :infinite-scroll-immediate="false"
        >
            <div class="table-main">
                <div v-for="(item, index) in dataList" :key="index" style="margin-right: 70px">
                    <div v-if="index >= startIdx && index <= endIdx" class="div-table-row table-item" :ref="'pl' + index">
                        <div class="div-table-cell" style="width: 3%; flex-grow: 1">{{ index + 1 }}</div>
                        <!--        编码            -->
                        <div class="div-table-cell apcode-cell table-cell-apcode">
                            <img
                                src="../../../assets/images/info.png"
                                alt=""
                                title="配件信息"
                                class="info-icon"
                                @click="showAPMsgDialog(item.EntpTempGoodsId)"
                                style="margin-left: 14px"
                                v-if="item.EntpTempGoodsId != ''"
                            />
                            <span :title="item.APCode">{{ item.APCode }}</span>
                        </div>
                        <!--        名称            -->
                        <div class="div-table-cell" style="width: 10%">
                            <div v-if="item.EntpTempGoodsId != ''">
                                <span :title="item.GoodName">{{ item.GoodName }}</span>
                            </div>
                            <el-input v-else size="small" placeholder="附加品名称" v-model="item.GoodName" :disabled="dataReadonly" :title="item.GoodName"></el-input>
                        </div>
                        <!--        车系            -->
                        <div class="div-table-cell" style="width: 10%">
                            <span :title="item.AutoSerise">{{ item.AutoSerise }}</span>
                        </div>
                        <!--        数量            -->
                        <div class="div-table-cell" style="width: 3%">
                            <span :title="item.Count">{{ item.Count }}</span>
                        </div>
                        <!--        单位         -->
                        <div class="div-table-cell" style="width: 3%">{{ item.Unit }}</div>
                        <!--        箱号           -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-input size="small" placeholder="箱号" v-model="item.PackingNo" :disabled="dataReadonly" :title="item.PackingNo"></el-input>
                        </div>
                        <!--        数量每箱          -->
                        <div class="div-table-cell" style="width: 5%">
                            <el-input
                                :min="0"
                                type="number"
                                size="small"
                                placeholder="数量/箱"
                                v-model="item.PCSEach"
                                :disabled="dataReadonly"
                                @input="boxChange"
                                :title="item.PCSEach"
                            ></el-input>
                        </div>
                        <!--        箱数          -->
                        <div class="div-table-cell" style="width: 5%">
                            <el-input
                                :min="0"
                                type="number"
                                size="small"
                                placeholder="箱数"
                                v-model="item.BoxCount"
                                :disabled="dataReadonly"
                                @input="boxChange"
                                :title="item.BoxCount"
                            ></el-input>
                        </div>
                        <!--        总个数          -->
                        <div class="div-table-cell" style="width: 5%">
                            <span :title="item.PCSEach * item.BoxCount ? item.PCSEach * item.BoxCount : item.PCSEach">{{
                                item.PCSEach * item.BoxCount ? item.PCSEach * item.BoxCount : item.PCSEach
                            }}</span>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-input
                                :min="0"
                                type="number"
                                step="0.01"
                                size="small"
                                placeholder="长"
                                v-model="item.Length"
                                :disabled="dataReadonly"
                                @input="cmbChange"
                                :title="item.Length"
                            ></el-input>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-input
                                :min="0"
                                type="number"
                                step="0.01"
                                size="small"
                                placeholder="宽"
                                v-model="item.Width"
                                :disabled="dataReadonly"
                                @input="cmbChange"
                                :title="item.Width"
                            ></el-input>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-input
                                :min="0"
                                type="number"
                                step="0.01"
                                size="small"
                                placeholder="高"
                                v-model="item.Height"
                                :disabled="dataReadonly"
                                @input="cmbChange"
                                :title="item.Height"
                            ></el-input>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <span :title="item.Length * item.Width * item.Height ? ((item.Length / 100) * (item.Width / 100) * (item.Height / 100)).toFixed(3) : 0">{{
                                item.Length * item.Width * item.Height ? ((item.Length / 100) * (item.Width / 100) * (item.Height / 100)).toFixed(3) : 0
                            }}</span>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <span
                                :title="
                                    item.Length * item.Width * item.Height * item.BoxCount
                                        ? ((item.Length / 100) * (item.Width / 100) * (item.Height / 100) * item.BoxCount).toFixed(3)
                                        : 0
                                "
                                >{{
                                    item.Length * item.Width * item.Height * item.BoxCount
                                        ? ((item.Length / 100) * (item.Width / 100) * (item.Height / 100) * item.BoxCount).toFixed(3)
                                        : 0
                                }}</span
                            >
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-input
                                type="number"
                                step="0.01"
                                size="small"
                                placeholder="重量"
                                v-model="item.Weight"
                                :disabled="dataReadonly"
                                @input="cmbChange"
                                :title="item.Weight"
                            ></el-input>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <span :title="item.Weight * item.BoxCount ? (item.Weight * item.BoxCount).toFixed(3) : 0">{{
                                item.Weight * item.BoxCount ? (item.Weight * item.BoxCount).toFixed(3) : 0
                            }}</span>
                        </div>
                        <div class="funcbtn">
                            <el-button class="less-btn" icon="el-icon-minus" circle @click="delItem(index, item)" v-if="!dataReadonly"></el-button>
                            <el-button class="add-btn" type="primary" icon="el-icon-plus" circle @click="addItem(index, item)" v-if="!dataReadonly"></el-button>
                        </div>
                    </div>
                </div>
                <div class="infinite-loading" v-if="showInfiniteLoading">
                    <i class="el-icon-loading">加载中</i>
                </div>
                <div style="margin-right: 70px" v-else>
                    <div class="div-table-row table-item">
                        <div class="div-table-cell" style="width: 3%; flex-grow: 1"></div>
                        <div class="div-table-cell table-cell-apcode"></div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 10%">总数量</div>
                        <div class="div-table-cell" style="width: 3%">
                            <el-tooltip effect="dark" placement="top" :content="allgoodscount ? allgoodscount.toString() : '0'">
                                <span>{{ allgoodscount }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 3%"></div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 5%">合计</div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" placement="top" :content="allboxescount ? allboxescount.toString() : '0'">
                                <span>{{ allboxescount }} (箱)</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" placement="top" :content="actuallycount ? actuallycount.toString() : '0'">
                                <span>{{ actuallycount }} (个)</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" placement="top" :content="cmbcount ? cmbcount.toString() : '0'">
                                <span>{{ cmbcount }} (m³)</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" placement="top" :content="kgcount ? kgcount.toString() : '0'">
                                <span>{{ kgcount }} (kg)</span>
                            </el-tooltip>
                        </div>
                        <div class="funcbtn">
                            <el-button class="add-btn" type="primary" icon="el-icon-plus" circle title="添加附加用品" @click="addExtraItem()" v-if="!dataReadonly"></el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   选择销售单    -->
        <el-dialog :close-on-click-modal="false" title="选择销售单（默认仅查询近一个月的销售单）" :visible.sync="showOrderSearchDialog" width="1200px">
            <selectSaleOrder @closeDialog="closeOrderDialog"></selectSaleOrder>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   销售单详细    -->
        <el-dialog :close-on-click-modal="false" title="销售单详细" :visible.sync="showOrderDetailDialog" :append-to-body="true" width="1400px">
            <div v-if="showOrderDetailDialog">
                <saleOrderDetail @closeDialog="closeOrderDetailDialog" :EntpCusOId="this.EntpCusOId"></saleOrderDetail>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import selectSaleOrder from '@/components/business/salesManage/selectSaleOrder';
import saleOrderDetail from '@/components/business/salesManage/saleOrderDetail';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        selectSaleOrder,
        APMsg,
        breadcrumb,
        saleOrderDetail
    },
    watch: {
        cmbcount: {
            handler(newVal, oldVal) {
                if (Number(this.type) != 1) this.addPageChace();
            }
        },
        kgcount: {
            handler(newVal, oldVal) {
                if (Number(this.type) != 1) this.addPageChace();
            }
        },
        dataList: {
            handler(newVal, oldVal) {
                if (Number(this.type) != 1) this.addPageChace();
            },
            deep: true
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            saleOrderSelected: true, //true是disable,反过来的
            submitStorageName: 'packingList',
            dataStorageName: 'packingList_dataList',
            PLId: '',
            EntpCusOId: '',
            needConfirm: true,
            loading: false,
            canRequest: true,
            dataReadonly: false,
            showOrderMsg: true,
            showOrderSearchDialog: false,
            showOrderDetailDialog: false,
            APMsgVisible: false,
            editData: {},
            editIndex: -1,
            submitData: {
                PackingCode: '',
                EntpCusId: '',
                PackingTime: new Date(),
                Remark: '',
                SId: userMsg.EmployeeId,
                SubmissionState: 0,
                DetailList: []
            },
            OrderData: {},
            saleOrderCodeList: [],
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            dataList: [],
            type: 0, //  1 查看 2 编辑 0 新增
            id: '',
            pageTitle: '',
            allgoodscount: 0,
            allboxescount: 0,
            actuallycount: 0,
            cmbcount: 0,
            kgcount: 0,
            rules: {
                Reasons: [{ required: true, message: '填写退货原因', trigger: 'blur' }]
            },
            allCount: 0,
            cmb: 0,

            startIdx: 0, // 列表显示的第一个列的下标
            endIdx: 49, // 列表显示的最后一个列的下标
            stopLoad: false, // 停止监听上下滚动
            windowHeight: window.innerHeight,
            infiniteListHeight: 0 // 列表高度，在收起信息栏时进行实时计算
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        this.getSIdList();
    },
    mounted() {
        let that = this;
        that.PLId = this.$route.query.PLId;
        that.type = this.$route.query.type;
        let localStorage = null;
        switch (Number(this.type)) {
            case 0:
                that.pageTitle = '新增装箱单';
                that.dataReadonly = false;
                localStorage = this.loadStorage();
                if (localStorage) {
                    this.getDataFromChace(localStorage);
                }
                break;
            case 1:
                that.pageTitle = '查看装箱单';
                that.dataReadonly = true;
                that.getPackingDetail();
                break;
            case 2:
                that.pageTitle = '编辑装箱单';
                that.dataReadonly = false;
                localStorage = this.loadStorage();
                if (localStorage) {
                    this.getDataFromChace(localStorage);
                } else {
                    that.getPackingDetail();
                }

                break;
        }
        // 监听滚动事件
        document.addEventListener('scroll', this.loadTopScroll, true);
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 100);
    },
    destroyed() {
        document.removeEventListener('scroll', this.loadTopScroll, true);
    },
    computed: {
        // 是否显示loading
        showInfiniteLoading() {
            return this.endIdx < this.dataList.length - 1;
        }
    },
    methods: {
        /**
         * 向上滚动
         * topValue: 距离顶部距离
         */
        loadTopScroll() {
            let topValue = document.getElementById('infinite-list').scrollTop;
            if (topValue > 150 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.startIdx > 0) {
                if (this.startIdx < 25) {
                    let over = this.startIdx;
                    this.startIdx -= Math.abs(over);
                    this.endIdx -= Math.abs(over);
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您现在在顶部'
                    });
                } else if (this.startIdx >= 25) {
                    this.startIdx -= 25;
                    this.endIdx -= 25;
                }
            }
            this.stopLoad = false;
        },
        // 向下滚动
        loadDownScroll() {
            let listLastIndex = this.dataList.length - 1;
            if (listLastIndex < 50 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.endIdx < listLastIndex) {
                if (this.endIdx + 25 <= listLastIndex) {
                    this.startIdx += 25;
                    this.endIdx += 25;
                } else {
                    let over = this.endIdx;
                    this.startIdx += listLastIndex - over;
                    this.endIdx += listLastIndex - over;
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您已经触底了哦~'
                    });
                }
            }
            this.stopLoad = false;
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        getMainStyle() {
            return 'padding-right:20px'; 
        },
        //箱子体积计算
        cmbChange() {
            let dataList = this.dataList;
            let _cmbcount = 0;
            let _kgcount = 0;
            for (let i = 0; i < dataList.length; i++) {
                _cmbcount += Number(
                    dataList[i].Length * dataList[i].Width * dataList[i].Height * dataList[i].BoxCount
                        ? ((dataList[i].Length / 100) * (dataList[i].Width / 100) * (dataList[i].Height / 100) * dataList[i].BoxCount).toFixed(3)
                        : 0
                );
                _kgcount += Number(dataList[i].Weight * dataList[i].BoxCount ? dataList[i].Weight * dataList[i].BoxCount : 0);
            }
            this.kgcount = _kgcount.toFixed(2);
            this.cmbcount = _cmbcount.toFixed(3);
        },
        // 箱子数量变化时
        boxChange() {
            let dataList = this.dataList;

            let _allgoodscount = 0;
            let _allboxescount = 0;
            let _actuallycount = 0;
            for (let i = 0; i < dataList.length; i++) {
                if (dataList[i].Count) {
                    if (typeof dataList[i].Count == 'number') {
                        _allgoodscount += dataList[i].Count;
                    }
                }
                _allboxescount += Number(dataList[i].BoxCount ? dataList[i].BoxCount : 0);
                _actuallycount += Number(dataList[i].PCSEach ? dataList[i].PCSEach : 0) * Number(dataList[i].BoxCount ? (dataList[i].BoxCount == 0 ? 1 : dataList[i].BoxCount) : 1);
            }
            this.allgoodscount = _allgoodscount;
            this.allboxescount = _allboxescount;
            this.actuallycount = _actuallycount;

            this.cmbChange();
        },
        showSalesDetails(id) {
            if (id) {
                this.EntpCusOId = id;
                this.showOrderDetailDialog = true;
            }
        },
        closeOrderDetailDialog() {
            this.showOrderDetailDialog = false;
        },
        //显示订单弹出层
        showOrderDialog() {
            this.showOrderSearchDialog = true;
        },
        //关闭订单弹出层
        closeOrderDialog(arr) {
            let that = this;
            that.showOrderSearchDialog = false;
            let codeList = [];
            if (!arr[0]) {
                this.$util.warningMsg('请至少选择一条数据进行创建装箱单');
                return;
            }
            let EntpCusOIds = arr.join(',');
            let url = '/api/EntpPackingList/GetEnterpriseCustomerSaleOrderDetails';
            that.loading = true;
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        EntpCusOIds: EntpCusOIds
                    },
                    hideLoading: true
                })
                .then(res => {
                    let result = res.data;

                    that.OrderData = result;
                    that.dataList = result.DetailList;
                    result.DetailList.forEach(element => {
                        codeList.push({
                            OrderCode: element.OrderCode,
                            EntpCusOId: element.EntpCusOId
                        });
                    });

                    that.saleOrderCodeList = that.uniq(codeList);
                    that.boxChange();
                    that.loading = false;
                    that.saleOrderSelected = false;
                });
        },
        // 获取详情
        getPackingDetail() {
            let that = this;
            let url = '/api/EntpPackingList/GetEnterprisePackingListById';
            let codeList = [];
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        PLId: that.PLId
                    }
                })
                .then(res => {
                    let data = res.data;
                    that.dataList = data.DetailList;
                    let tempCusOId = '';
                    let tempAPCode = '';

                    for (let i = 0; i < that.dataList.length; i++) {
                        const e1 = that.dataList[i];
                        for (let j = i + 1; j < that.dataList.length; j++) {
                            const e2 = that.dataList[j];
                            if (e1.EntpCusOId == e2.EntpCusOId) {
                                if (e1.APCode == e2.APCode) {
                                    e2.Count = '-';
                                }
                            }
                        }
                    }
                    that.submitData = data;

                    //销售单的这些信息只是为了展示而已
                    that.OrderData = {
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName,
                        ShipTypeName: data.ShipTypeName,
                        SName: data.SName,
                        FullAddress: data.FullAddress,
                        Remark: data.OrderRemark,
                        OrderList: data.OrderList
                    };

                    data.OrderList.forEach(element => {
                        codeList.push({
                            OrderCode: element.OrderCode,
                            EntpCusOId: element.EntpCusOId
                        });
                    });

                    that.saleOrderCodeList = that.uniq(codeList);

                    that.SIdList = [];
                    that.SIdList.push({
                        EmployeeId: data.SId,
                        EmployeeName: data.SName
                    });

                    that.boxChange();
                    that.saleOrderSelected = false;
                });
        },
        // 提交装箱单
        submitForm(SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (SubmissionState == 1) {
                        for (let i = 0; i < _dataList.length; i++) {
                            if (!_dataList[i].PackingNo) {
                                this.$util.warningMsg('请填写箱号');
                                return;
                            }
                            if (!_dataList[i].PCSEach) {
                                this.$util.warningMsg('请填写每箱数量');
                                return;
                            } else if (_dataList[i].PCSEach < 0) {
                                this.$util.warningMsg('请正确填写每箱数量');
                                return;
                            }
                            if (!_dataList[i].BoxCount) {
                                // _dataList[i].BoxCount = 0;
                                // this.$util.warningMsg("请填写箱数");
                                // return;
                            } else if (_dataList[i].BoxCount < 0) {
                                this.$util.warningMsg('请正确填写箱数');
                                return;
                            }
                            if (!_dataList[i].Length) {
                                this.$util.warningMsg('请填写箱的长度');
                                return;
                            } else if (_dataList[i].Length < 0) {
                                this.$util.warningMsg('请正确填写箱的长度');
                                return;
                            }
                            if (!_dataList[i].Width) {
                                this.$util.warningMsg('请填写箱的宽度');
                                return;
                            } else if (_dataList[i].Width < 0) {
                                this.$util.warningMsg('请正确填写箱的宽度');
                                return;
                            }
                            if (!_dataList[i].Height) {
                                this.$util.warningMsg('请填写箱的高度');
                                return;
                            } else if (_dataList[i].Height < 0) {
                                this.$util.warningMsg('请正确填写箱的高度');
                                return;
                            }
                            if (this.allgoodscount < this.actuallycount) {
                                this.$util.warningMsg('请填写正确的装箱数量或数量已超过可装箱数量');
                                return;
                            }
                        }
                    }
                    _dataList.forEach((e, i) => (e.SortNum = i + 1));
                    this.submitData.EntpCusId = this.OrderData.EntpCusId;
                    this.submitData.EntpCusName = this.OrderData.EntpCusName;
                    this.submitData.FullAddress = this.OrderData.FullAddress;
                    this.submitData.ShipType = this.OrderData.ShipType;
                    this.submitData.ShipTypeName = this.OrderData.ShipTypeName;

                    this.submitData.SubmissionState = SubmissionState;
                    this.submitData.DetailList = _dataList;
                    if (!this.canRequest) {
                        return;
                    }
                    this.canRequest = false;
                    this.$util
                        .axiosPost({
                            url: '/api/EntpPackingList/SaveEnterpriseCustomerPackingList',
                            data: this.submitData
                        })
                        .then(() => {
                            this.needConfirm = false;
                            if (SubmissionState == 1) {
                                this.$util.successMsg('提交装箱单成功');
                            } else {
                                this.$util.successMsg('保存装箱单成功');
                            }
                            //编辑后列表页面需要刷新
                            this.$store.commit('updateNeedRefresh', true);
                            this.removePageChace();
                            setTimeout(() => {
                                this.canRequest = true;
                                this.$router.push('/inventoryManage/packingList');
                            }, 2000);
                        })
                        .catch(() => {
                            this.canRequest = true;
                        });
                } else {
                    this.$util.warningMsg('有必填项未填写');
                }
            });
        },
        // 删除某行
        delItem(index) {
            this.dataList.splice(index, 1);
            this.boxChange();
            this.addPageChace();
        },
        // 添加一行
        addItem(index, item) {
            this.dataList.splice(index + 1, 0, {
                EntpTempGoodsId: item.EntpTempGoodsId,
                APCode: item.APCode,
                GoodName: item.GoodName,
                AutoSerise: item.AutoSerise,
                Count: '',
                EntpCusOId: item.EntpCusOId,
                Unit: '',
                OrderCode: item.OrderCode,
                RId: item.RId,
                Weight: 0
            });

            // 当dataList数量大于50时
            if (this.dataList.length > 50) {
                this.startIdx += 1;
                this.endIdx += 1;
            }

            this.boxChange();
        },
        //添加附加货物--不在订单里面的
        addExtraItem() {
            this.dataList.splice(this.dataList.length, 0, {
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Count: '',
                EntpCusOId: '',
                Unit: '',
                OrderCode: '',
                RId: '',
                Weight: 0
            });

            // 当dataList数量大于50时
            if (this.dataList.length > 50) {
                this.startIdx += 1;
                this.endIdx += 1;
            }

            this.addPageChace();
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        //判断是否有缓存,加载缓存或者请求订单信息
        loadStorage() {
            let saleOrderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (saleOrderModel && datalist && datalist.length > 0) {
                return {
                    model: saleOrderModel,
                    list: datalist
                };
            } else {
                return null;
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.submitStorageName, this.OrderData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //获取缓存
        getDataFromChace(data) {
            let saleOrderModel = data.model;
            let datalist = data.list;

            if (saleOrderModel) {
                this.OrderData = saleOrderModel;
            }
            if (datalist && datalist.length > 0) {
                let codeList = [];
                this.dataList = datalist;
                if (saleOrderModel.OrderList) {
                    saleOrderModel.OrderList.forEach(element => {
                        codeList.push({
                            OrderCode: element.OrderCode,
                            EntpCusOId: element.EntpCusOId
                        });
                    });
                } else {
                    datalist.forEach(element => {
                        if (element.OrderCode && element.OrderCode != '') {
                            codeList.push({
                                OrderCode: element.OrderCode,
                                EntpCusOId: element.EntpCusOId
                            });
                        }
                    });
                }
                this.saleOrderCodeList = this.uniq(codeList);
                this.boxChange();
                this.saleOrderSelected = false;
            }
        },
        getSIdList() {
            this.$util.getSalemanList().then(data => {
                this.SIdList = data;
            });
        },
        //集合去重，如果多引用则放到 common.js
        uniq(array) {
            let temp = [];
            let index = [];
            let l = array.length;
            for (let i = 0; i < l; i++) {
                for (let j = i + 1; j < l; j++) {
                    if (array[i].OrderCode === array[j].OrderCode) {
                        i++;
                        j = i;
                    }
                }
                temp.push({
                    OrderCode: array[i].OrderCode,
                    EntpCusOId: array[i].EntpCusOId
                });
                index.push(i);
            }
            return temp;
        }
    }
};
</script>
<style lang="less" scoped>
.business-content-main {
    min-width: 1600px;
}
.codetags {
    display: flex;
    flex-direction: row;
    height: 40px;
    align-items: center;
    span {
        margin-right: 4px;
    }
}
.funcbtn {
    position: absolute;
    right: -60px;
    display: flex;
    flex-direction: row;
    width: 70px;
    height: 36px;
    align-items: center;
    justify-content: center;
}
.search-ctn {
    border: 1px solid @border3Color;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    width: 34px;
    margin-left: 0;
}
.less-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    width: 34px;
    margin-left: 20px;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;height: 36px;
}
.apcode-cell {
    display: flex;
    justify-content: flex-start;
}
.table-item {
    height: 36px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
</style>
<style lang="less">
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.table-cell-apcode {
    min-width: 200px;
}
.packing-order-infoes {
    margin-bottom: 10px;
    .el-form {
        padding-top: 10px;
    }
    .el-row {
        padding-bottom: 10px;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }

    .form-main {
        display: flex;
        align-items: center;
    }
}
</style>
